// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 120) return "js/core/120.js";
	if (chunkId === 856) return "js/core/856.js";
	if (chunkId === 861) return "js/core/861.js";
	// return url for filenames based on template
	return undefined;
};